export const RATE_LIMIT_STATUS_TEST_IDS = {
  rateLimitStatus: 'chatbot-rate-limit-status',
  rateLimitInfoButton: 'chatbot-rate-limit-info-button',
  rateLimitTooltip: 'chatbot-rate-limit-tooltip',
};
